export const environment = {
  production: false,
  // Azure B2C Login
  oidc: {
    discDocURL: 'https://devsuiteedge.b2clogin.com/devsuiteedge.onmicrosoft.com/b2c_1_susi_dev/v2.0/.well-known/openid-configuration',
    clientId: '40f772aa-909e-4dab-95ac-2c8c4cdb64b5',
    scope: 'openid https://devsuiteedge.onmicrosoft.com/d90df4f4-bc51-4d1d-bc07-08ab708d31c9/user_impersonation',
    pwdResetURL: 'https://devsuiteedge.b2clogin.com/devsuiteedge.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_PWDR_DEV&client_id=40f772aa-909e-4dab-95ac-2c8c4cdb64b5&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fcarrierportal.dev.lynnco.com&scope=openid&response_type=id_token&prompt=login',
    allowedURLs: ['http://localhost:4200', 'https://dev-carrierportal.azurewebsites.net', 'https://carrierportal.dev.lynnco.com'],
  },

  userAccess: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/Users',
  groups: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/Groups',
  roles: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/Role',
  permissions: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/CarrierPermission',
  permRole: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/RolePermission',
  notification: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/SuiteEdge_Notifications',

  externalUrls: {
    mgBase: 'https://qa-lynnco.mercurygate.net/MercuryGate/login/mgLogin.jsp'
  },
  suiteSearch: {
    url: 'https://dev-as-lynnco-search2.search.windows.net/indexes/lynnco-azure-carrier-search-new/docs/search?api-version=2016-09-01'
  },
  shipmentPortal: {
    userHierarchy: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/GetActiveCustomersByTMSID',
    masterList: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/GetAllTMSActiveCustomers',
  },
  suiteReports: {
    invoiceStatus: 'https://dev-apim-lynsafe.azure-api.net/api/carrierportal/fa/Reports_CarrierInvStatus/'
  }
};
